/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { clinicPathwaysControllerCreate } from '../fn/clinic-pathways/clinic-pathways-controller-create';
import { ClinicPathwaysControllerCreate$Params } from '../fn/clinic-pathways/clinic-pathways-controller-create';
import { clinicPathwaysControllerFilter } from '../fn/clinic-pathways/clinic-pathways-controller-filter';
import { ClinicPathwaysControllerFilter$Params } from '../fn/clinic-pathways/clinic-pathways-controller-filter';
import { clinicPathwaysControllerFindByClinicIdAndType } from '../fn/clinic-pathways/clinic-pathways-controller-find-by-clinic-id-and-type';
import { ClinicPathwaysControllerFindByClinicIdAndType$Params } from '../fn/clinic-pathways/clinic-pathways-controller-find-by-clinic-id-and-type';
import { clinicPathwaysControllerGetStandardTests } from '../fn/clinic-pathways/clinic-pathways-controller-get-standard-tests';
import { ClinicPathwaysControllerGetStandardTests$Params } from '../fn/clinic-pathways/clinic-pathways-controller-get-standard-tests';
import { clinicPathwaysControllerUpdatePricing } from '../fn/clinic-pathways/clinic-pathways-controller-update-pricing';
import { ClinicPathwaysControllerUpdatePricing$Params } from '../fn/clinic-pathways/clinic-pathways-controller-update-pricing';
import { clinicPathwaysControllerUpdateStatus } from '../fn/clinic-pathways/clinic-pathways-controller-update-status';
import { ClinicPathwaysControllerUpdateStatus$Params } from '../fn/clinic-pathways/clinic-pathways-controller-update-status';
import { GetStandardTestsResponseDto } from '../models/get-standard-tests-response-dto';
import { ResponseClinicPathwayDto } from '../models/response-clinic-pathway-dto';

@Injectable({ providedIn: 'root' })
export class ClinicPathwaysService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `clinicPathwaysControllerFilter()` */
  static readonly ClinicPathwaysControllerFilterPath = '/thalea-pathways/clinic-pathways/filter';

  /**
   * Filter clinic pathways.
   *
   * Retrieves clinic pathways based on filtering criteria.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `clinicPathwaysControllerFilter()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  clinicPathwaysControllerFilter$Response(params: ClinicPathwaysControllerFilter$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ResponseClinicPathwayDto>>> {
    return clinicPathwaysControllerFilter(this.http, this.rootUrl, params, context);
  }

  /**
   * Filter clinic pathways.
   *
   * Retrieves clinic pathways based on filtering criteria.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `clinicPathwaysControllerFilter$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  clinicPathwaysControllerFilter(params: ClinicPathwaysControllerFilter$Params, context?: HttpContext): Observable<Array<ResponseClinicPathwayDto>> {
    return this.clinicPathwaysControllerFilter$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ResponseClinicPathwayDto>>): Array<ResponseClinicPathwayDto> => r.body)
    );
  }

  /** Path part for operation `clinicPathwaysControllerFindByClinicIdAndType()` */
  static readonly ClinicPathwaysControllerFindByClinicIdAndTypePath = '/thalea-pathways/clinic-pathways/{tenant}/{clinicId}/{type}';

  /**
   * Get clinic pathway by clinic ID and type.
   *
   * Retrieves a specific clinic pathway configuration.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `clinicPathwaysControllerFindByClinicIdAndType()` instead.
   *
   * This method doesn't expect any request body.
   */
  clinicPathwaysControllerFindByClinicIdAndType$Response(params: ClinicPathwaysControllerFindByClinicIdAndType$Params, context?: HttpContext): Observable<StrictHttpResponse<ResponseClinicPathwayDto>> {
    return clinicPathwaysControllerFindByClinicIdAndType(this.http, this.rootUrl, params, context);
  }

  /**
   * Get clinic pathway by clinic ID and type.
   *
   * Retrieves a specific clinic pathway configuration.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `clinicPathwaysControllerFindByClinicIdAndType$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  clinicPathwaysControllerFindByClinicIdAndType(params: ClinicPathwaysControllerFindByClinicIdAndType$Params, context?: HttpContext): Observable<ResponseClinicPathwayDto> {
    return this.clinicPathwaysControllerFindByClinicIdAndType$Response(params, context).pipe(
      map((r: StrictHttpResponse<ResponseClinicPathwayDto>): ResponseClinicPathwayDto => r.body)
    );
  }

  /** Path part for operation `clinicPathwaysControllerUpdatePricing()` */
  static readonly ClinicPathwaysControllerUpdatePricingPath = '/thalea-pathways/clinic-pathways/{tenant}/{clinicId}/{type}/pricing';

  /**
   * Update clinic pathway pricing.
   *
   * Updates pricing and configuration for a clinic pathway.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `clinicPathwaysControllerUpdatePricing()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  clinicPathwaysControllerUpdatePricing$Response(params: ClinicPathwaysControllerUpdatePricing$Params, context?: HttpContext): Observable<StrictHttpResponse<ResponseClinicPathwayDto>> {
    return clinicPathwaysControllerUpdatePricing(this.http, this.rootUrl, params, context);
  }

  /**
   * Update clinic pathway pricing.
   *
   * Updates pricing and configuration for a clinic pathway.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `clinicPathwaysControllerUpdatePricing$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  clinicPathwaysControllerUpdatePricing(params: ClinicPathwaysControllerUpdatePricing$Params, context?: HttpContext): Observable<ResponseClinicPathwayDto> {
    return this.clinicPathwaysControllerUpdatePricing$Response(params, context).pipe(
      map((r: StrictHttpResponse<ResponseClinicPathwayDto>): ResponseClinicPathwayDto => r.body)
    );
  }

  /** Path part for operation `clinicPathwaysControllerUpdateStatus()` */
  static readonly ClinicPathwaysControllerUpdateStatusPath = '/thalea-pathways/clinic-pathways/{tenant}/{clinicId}/{type}/status/{status}';

  /**
   * Update clinic pathway status.
   *
   * Updates the status of a clinic pathway (ACTIVE, INACTIVE, CANCELED).
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `clinicPathwaysControllerUpdateStatus()` instead.
   *
   * This method doesn't expect any request body.
   */
  clinicPathwaysControllerUpdateStatus$Response(params: ClinicPathwaysControllerUpdateStatus$Params, context?: HttpContext): Observable<StrictHttpResponse<ResponseClinicPathwayDto>> {
    return clinicPathwaysControllerUpdateStatus(this.http, this.rootUrl, params, context);
  }

  /**
   * Update clinic pathway status.
   *
   * Updates the status of a clinic pathway (ACTIVE, INACTIVE, CANCELED).
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `clinicPathwaysControllerUpdateStatus$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  clinicPathwaysControllerUpdateStatus(params: ClinicPathwaysControllerUpdateStatus$Params, context?: HttpContext): Observable<ResponseClinicPathwayDto> {
    return this.clinicPathwaysControllerUpdateStatus$Response(params, context).pipe(
      map((r: StrictHttpResponse<ResponseClinicPathwayDto>): ResponseClinicPathwayDto => r.body)
    );
  }

  /** Path part for operation `clinicPathwaysControllerGetStandardTests()` */
  static readonly ClinicPathwaysControllerGetStandardTestsPath = '/thalea-pathways/clinic-pathways/{tenant}/{clinicId}';

  /**
   * Get all standard tests for a clinic.
   *
   * Retrieves all tests from all phases of all active pathways for a specific clinic.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `clinicPathwaysControllerGetStandardTests()` instead.
   *
   * This method doesn't expect any request body.
   */
  clinicPathwaysControllerGetStandardTests$Response(params: ClinicPathwaysControllerGetStandardTests$Params, context?: HttpContext): Observable<StrictHttpResponse<GetStandardTestsResponseDto>> {
    return clinicPathwaysControllerGetStandardTests(this.http, this.rootUrl, params, context);
  }

  /**
   * Get all standard tests for a clinic.
   *
   * Retrieves all tests from all phases of all active pathways for a specific clinic.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `clinicPathwaysControllerGetStandardTests$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  clinicPathwaysControllerGetStandardTests(params: ClinicPathwaysControllerGetStandardTests$Params, context?: HttpContext): Observable<GetStandardTestsResponseDto> {
    return this.clinicPathwaysControllerGetStandardTests$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetStandardTestsResponseDto>): GetStandardTestsResponseDto => r.body)
    );
  }

  /** Path part for operation `clinicPathwaysControllerCreate()` */
  static readonly ClinicPathwaysControllerCreatePath = '/thalea-pathways/clinic-pathways';

  /**
   * Create clinic pathway.
   *
   * Creates a new clinic pathway configuration.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `clinicPathwaysControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  clinicPathwaysControllerCreate$Response(params: ClinicPathwaysControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<ResponseClinicPathwayDto>> {
    return clinicPathwaysControllerCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * Create clinic pathway.
   *
   * Creates a new clinic pathway configuration.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `clinicPathwaysControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  clinicPathwaysControllerCreate(params: ClinicPathwaysControllerCreate$Params, context?: HttpContext): Observable<ResponseClinicPathwayDto> {
    return this.clinicPathwaysControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<ResponseClinicPathwayDto>): ResponseClinicPathwayDto => r.body)
    );
  }

}
